import React, { useState, useEffect } from 'react';
import { Text, Button } from 'mintel-react-ui';

import useTranslation from '../translations';
import { StringField } from '../fields';
import { changeLanguage, handleEmailSubmit } from '../shared/utils';
import { EmailInputWrapper } from '../InputWrapper';
import PageWrapper from '../PageWrapper';
import styles from './RecoverPassword.scss';

export type RecoverPasswordProps = {
  fields: { email: StringField; csrf: StringField };
  backLink: string;
  language?: string;
};

const RecoverPassword = ({
  fields,
  backLink,
  language,
}: RecoverPasswordProps): JSX.Element => {
  const { t } = useTranslation();
  useEffect(() => {
    changeLanguage(language);
  }, [language]);
  const [email, setEmail] = useState(fields.email.value || '');
  const [error, setError] = useState<string | null>(null);

  return (
    <PageWrapper>
      <form method="POST" className={styles.root}>
        <div>
          <Text.Heading2>{t('Recover Password')}</Text.Heading2>
        </div>
        <div className={styles.description}>
          <Text.Body2>
            {t(
              "Don't worry, this happens to the best of us. Please confirm your email address and we will send you a reset link immediately.",
            )}
          </Text.Body2>
        </div>
        <EmailInputWrapper
          fields={fields}
          email={email}
          error={error}
          setEmail={setEmail}
          setError={setError}
        />
        <div>
          <Button.ActionButton
            type="submit"
            disabled={!email.length}
            fullWidth
            handleClick={(e: React.MouseEvent<HTMLButtonElement>) => {
              handleEmailSubmit(e, email, t, setError);
            }}
          >
            {t('Email me a recovery link')}
          </Button.ActionButton>
        </div>
        <div className={styles.backButton}>
          <Text.Body2>
            <a href={backLink || '/'}>{t('Back to login')}</a>
          </Text.Body2>
        </div>
      </form>
    </PageWrapper>
  );
};

export default RecoverPassword;
